export default {"src":"/_next/static/media/swap.58757fe7.svg","height":160,"width":231};